/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Document } from '../models/Document';
import { Extension } from '../models/Extension';
import { Node } from '../models/Node';
import { ValidationProblem } from '../models/ValidationProblem';
import { Contact } from '../models/common/Contact';
import { ExternalDocumentation } from '../models/common/ExternalDocumentation';
import { IDefinition } from '../models/common/IDefinition';
import { Info } from '../models/common/Info';
import { License } from '../models/common/License';
import { Operation } from '../models/common/Operation';
import { Parameter } from '../models/common/Parameter';
import { Schema } from '../models/common/Schema';
import { SecurityRequirement } from '../models/common/SecurityRequirement';
import { SecurityScheme } from '../models/common/SecurityScheme';
import { Tag } from '../models/common/Tag';

/**
 * Visitor used to visit all nodes in the same way.
 * @author eric.wittmann@gmail.com
 * @class
 */
export class AllNodeVisitor implements IVisitor {
    visitNode(node : Node) {
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitDocument(io.apicurio.datamodels.core.models.Document)
     * @param {Document} node
     */
    public visitDocument(node : Document) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitExtension(io.apicurio.datamodels.core.models.Extension)
     * @param {Extension} node
     */
    public visitExtension(node : Extension) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitInfo(io.apicurio.datamodels.core.models.common.Info)
     * @param {Info} node
     */
    public visitInfo(node : Info) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitContact(io.apicurio.datamodels.core.models.common.Contact)
     * @param {Contact} node
     */
    public visitContact(node : Contact) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitLicense(io.apicurio.datamodels.core.models.common.License)
     * @param {License} node
     */
    public visitLicense(node : License) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitTag(io.apicurio.datamodels.core.models.common.Tag)
     * @param {Tag} node
     */
    public visitTag(node : Tag) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitExternalDocumentation(io.apicurio.datamodels.core.models.common.ExternalDocumentation)
     * @param {ExternalDocumentation} node
     */
    public visitExternalDocumentation(node : ExternalDocumentation) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSecurityRequirement(io.apicurio.datamodels.core.models.common.SecurityRequirement)
     * @param {SecurityRequirement} node
     */
    public visitSecurityRequirement(node : SecurityRequirement) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitValidationProblem(io.apicurio.datamodels.core.models.ValidationProblem)
     * @param {ValidationProblem} problem
     */
    public visitValidationProblem(problem : ValidationProblem) {
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSchema(io.apicurio.datamodels.core.models.common.Schema)
     * @param {Schema} node
     */
    public visitSchema(node : Schema) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitParameter(io.apicurio.datamodels.core.models.common.Parameter)
     * @param {Parameter} node
     */
    public visitParameter(node : Parameter) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitParameterDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitParameterDefinition(node : IDefinition) {
        this.visitNode(<Node><any>node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitOperation(io.apicurio.datamodels.core.models.common.Operation)
     * @param {Operation} node
     */
    public visitOperation(node : Operation) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSecurityScheme(io.apicurio.datamodels.core.models.common.SecurityScheme)
     * @param {SecurityScheme} node
     */
    public visitSecurityScheme(node : SecurityScheme) {
        this.visitNode(node);
    }

    /**
     * @see io.apicurio.datamodels.core.visitors.IVisitor#visitSchemaDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitSchemaDefinition(node : IDefinition) {
        this.visitNode(<Node><any>node);
    }

    constructor() {
    }
}
AllNodeVisitor["__class"] = "io.apicurio.datamodels.core.visitors.AllNodeVisitor";
AllNodeVisitor["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor"];





import { IVisitor } from './IVisitor';

